/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Proof_H1_LabelInputs */

const en_dr_proof_h1_label = /** @type {(inputs: Dr_Proof_H1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H-1`)
};

const id_dr_proof_h1_label = /** @type {(inputs: Dr_Proof_H1_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`H-1`)
};

/**
* | output |
* | --- |
* | "H-1" |
*
* @param {Dr_Proof_H1_LabelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_proof_h1_label = /** @type {((inputs?: Dr_Proof_H1_LabelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Proof_H1_LabelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_proof_h1_label(inputs)
	return en_dr_proof_h1_label(inputs)
});